var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedSupplyReqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.77197,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.77197,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#C1CFE0",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.772 23.9938L35.6665 20.5404L36.0992 15.9689L31.5047 14.9503L29.0992 11L24.772 12.8137L20.4447 11L18.0392 14.9503L13.4447 15.9565L13.8774 20.528L10.772 23.9938L13.8774 27.4472L13.4447 32.0311L18.0392 33.0497L20.4447 37L24.772 35.1739L29.0992 36.9876L31.5047 33.0373L36.0992 32.0186L35.6665 27.4472L38.772 23.9938ZM22.2265 30.205L17.1356 25.236L18.9302 23.4845L22.2265 26.6894L30.6138 18.5031L32.4083 20.2671L22.2265 30.205Z",
    fill: "#66A617"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedSupplyReqIcon);
export default __webpack_public_path__ + "static/media/completed-supply-req-icon.4350a644b6a90562dd5dfd166e61dc4c.svg";
export { ForwardRef as ReactComponent };